import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import NavProduct from '../comps/NavProduct';
import TabBundles from '../comps/TabBundles';
import TabSpecs from '../comps/TabSpecs';
import TabSupport from '../comps/TabSupport';
import { useProductDispatch, useProductStore } from '../ProductProvider';
import styles from './index.module.scss';
import ProductContent from './ProductContent';

const theme = 'white';
const tabList = ['Product', 'Recycling', 'Specs', 'Support', 'Media'];
export default function Detail() {
    const { productTabActive } = useProductStore();
    const dispatch = useProductDispatch();
    const router = useRouter();
    const { query } = router;
    const tabName: string = (query.tab as string) || '';

    useEffect(() => {
        if (tabName && tabList.includes(tabName)) {
            dispatch({
                type: 'changeProductTabActive',
                payload: tabName,
            });
        }
    }, [tabName]);

    return (
        <div className={styles.detail}>
            <NavProduct />
            <div className={`product-item-tab${productTabActive === 'Product' ? ' product-item-tab-active' : ''}`}>
                <ProductContent />
            </div>
            {productTabActive === 'Bundles' && (
                <div className={`product-item-tab product-item-tab-active`}>
                    <TabBundles />
                </div>
            )}
            {productTabActive === 'Support' && (
                <div className={`product-item-tab product-item-tab-active`}>
                    <TabSupport theme={theme} />
                </div>
            )}
            {productTabActive === 'Specs' && (
                <div className={`product-item-tab product-item-tab-active`}>
                    <TabSpecs theme={theme} />
                </div>
            )}
        </div>
    );
}
